declare global {
  interface Window {
    lyDataLayer?: unknown[];
    lytag?: (...args: unknown[]) => void;
  }
}

const TAG_ID = 'd26c43ec-644e-4a45-a2b5-58e9ba55db00';
let lytagInitialized = false;

/** グローバルタグ読み込み + init + page_view */
export function initLytag(): void {
  if (lytagInitialized) return;
  lytagInitialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://tag.flvcdn.net/lytag.js';
  document.head.appendChild(script);

  window.lyDataLayer = window.lyDataLayer || [];
  window.lytag = function () { window.lyDataLayer!.push(Array.from(arguments)); };

  window.lytag({ type: 'init', tagId: TAG_ID, config: { useCookie: true, useLocalStorage: true } });
  window.lytag({ type: 'event', eventType: 'page_view', tagId: TAG_ID });
}

/** コンバージョン: 無料体験申込完了 */
export function trackTrialSignup(): boolean {
  try {
    if (!window.lytag) return false;
    window.lytag({
      type: 'event',
      eventType: 'sign_up',
      tagId: TAG_ID,
      config: { snippetId: '37f78d0e-8e5c-4324-b868-48f640c7e8a8' },
    });
    return true;
  } catch {
    return false;
  }
}
